import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { useState, useEffect } from 'react';
import { useWebpOrJpg } from '../../../hooks/useWebpOrJpg';

interface ItemType {
    img: string[];
    name: string;
    text: string;
    webp: string[];
}
export default function Modal({ callback }: any) {
    const { t } = useLang('dpux');
    const webpOrJpg = useWebpOrJpg();

    const [visible, setVisible] = useState(false);
    const items: ItemType[] = [
        {
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1758943192677/I-dialog2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758943193255/I-dialog2-m.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1758943322545/I-dialog2.webp',
                'https://websiteoss.ecoflow.com/upload/image/1758943322998/I-dialog2-m.webp',
            ],
            name: t('I_modal_name1'),
            text: t('I_modal_text1'),
        },
        {
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1758943193046/I-dialog1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758943192858/I-dialog1-m.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1758943322801/I-dialog1.webp',
                'https://websiteoss.ecoflow.com/upload/image/1758943322311/I-dialog1-m.webp',
            ],
            name: t('I_modal_name2'),
            text: t('I_modal_text2'),
        },
    ];

    const handleClose = () => {
        setVisible(false);
        setTimeout(() => {
            callback();
        }, 200);
    };

    useEffect(() => {
        setTimeout(() => {
            setVisible(true);
        }, 200);
    }, []);

    return (
        <div
            className={`dpux-modal-terms ${css.modal} GtmModuleData-section ${visible ? 'visible' : ''}`}
            data-section-id={css.modal}
            data-section-title={t('I_modal_title')}
        >
            <div className={`content ${visible ? 'visible' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none" onClick={handleClose}>
                    <circle cx="10" cy="10" r="10" fill="white" fillOpacity="0.4" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.76758 9.82812L6.46918 12.1265C6.17629 12.4194 6.17629 12.8943 6.46918 13.1872C6.76207 13.4801 7.23695 13.4801 7.52984 13.1872L9.82824 10.8888L12.1266 13.1872C12.4195 13.4801 12.8944 13.4801 13.1873 13.1872C13.4802 12.8943 13.4802 12.4194 13.1873 12.1265L10.8889 9.82812L13.1867 7.53033C13.4796 7.23744 13.4796 6.76256 13.1867 6.46967C12.8938 6.17678 12.4189 6.17678 12.126 6.46967L9.82824 8.76746L7.53045 6.46967C7.23755 6.17678 6.76268 6.17678 6.46979 6.46967C6.17689 6.76256 6.17689 7.23744 6.46979 7.53033L8.76758 9.82812Z"
                        fill="white"
                    />
                </svg>
                <p className="modal-title">{t('I_modal_title')}</p>
                <ul className="modal-items">
                    {items.map((item: ItemType, k: number) => (
                        <li className="modal-item" key={k}>
                            <EcoImg className="modal-item-img" pc={webpOrJpg(item.img[0], item.webp[0])} h5={webpOrJpg(item.img[1], item.webp[1])} />
                            <p className="modal-item-name">{item.name}</p>
                            <p className="modal-item-text">{item.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
